<template>
  <div id="MyHealthList">
    <div v-if="services.length" class="row">
      <div
        v-for="(service, index) in services"
        :key="index"
        class="col-12 col-md-6 col-lg-4 p-3"
      >
        <b-button
          @click="() => handleClick(service)"
          class="my-health-item"
          :class="
            isAdditionalInfoShown ? 'align-items-start' : 'align-items-center'
          "
        >
          <img
            v-if="service.icon"
            :src="`/img/my-health/${service.icon}.png`"
            :alt="service.title"
            class="my-health-img mr-3"
          />
          <div class="my-health-details">
            <p class="my-health-title brand-highlight-3">{{ service.title }}</p>
            <p
              v-if="isAdditionalInfoShown && service.subtitle"
              class="my-health-subtitle"
            >
              {{ service.subtitle }}
            </p>
            <div
              v-if="isAdditionalInfoShown && service.plan_tag"
              :style="{ color: service.plan_tag.color || '#000' }"
              class="my-health-tag-container"
            >
              <svg
                width="12"
                height="13"
                viewBox="0 0 12 13"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4.42655 1.28904C5.22049 0.236986 6.7795 0.236985 7.57345 1.28904C7.95674 1.79694 8.55433 2.08963 9.18374 2.07774C10.4875 2.0531 11.4595 3.29276 11.1458 4.58002C10.9943 5.20146 11.1419 5.85913 11.5435 6.3522C12.3753 7.37353 12.0284 8.91936 10.8433 9.47249C10.2711 9.73952 9.85755 10.2669 9.7289 10.8937C9.4624 12.1919 8.05778 12.8799 6.89365 12.2823C6.33164 11.9939 5.66836 11.9939 5.10635 12.2823C3.94222 12.8799 2.5376 12.1919 2.2711 10.8937C2.14244 10.2669 1.7289 9.73952 1.15674 9.47249C-0.0284198 8.91936 -0.375332 7.37353 0.45649 6.3522C0.858067 5.85913 1.00566 5.20146 0.8542 4.58002C0.540468 3.29276 1.5125 2.0531 2.81626 2.07774C3.44567 2.08963 4.04326 1.79694 4.42655 1.28904Z"
                  :fill="service.plan_tag.color || '#000'"
                />
                <path
                  d="M8.4375 5.19922L5.4375 8.19922C5.34375 8.29297 5.22656 8.33984 5.10938 8.33984C4.99219 8.33984 4.86328 8.29297 4.78125 8.19922L3.28125 6.69922C3.09375 6.51172 3.09375 6.21875 3.28125 6.03125C3.45703 5.85547 3.75 5.85547 3.9375 6.03125L5.10938 7.20312L7.78125 4.53125C7.95703 4.35547 8.25 4.35547 8.4375 4.53125C8.625 4.71875 8.625 5.01172 8.4375 5.19922Z"
                  fill="white"
                />
              </svg>
              <span v-if="service.plan_tag.text" class="ml-2">{{
                service.plan_tag.text
              }}</span>
            </div>
          </div>
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MyHealthList",
  props: {
    services: {
      type: Array,
      required: true,
      default: () => []
    },
    handleClick: {
      type: Function,
      required: true
    },
    isAdditionalInfoShown: {
      type: Boolean,
      required: false,
      default: false
    }
  }
};
</script>

<style lang="less">
#MyHealthList {
  .my-health-details {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    margin-left: 20px;
  }

  .my-health-item {
    display: flex;
    justify-content: flex-start;
    width: 100%;
    height: 100%;
    background-color: #fff;
    font-size: 2rem;
    min-height: 112px;
    letter-spacing: 0;
    border: 1px solid #e0e5f5;
    border-radius: 8px;
    padding: 2rem;
    box-shadow: 0px 2px 16px 0px #0000000a;

    &:hover, &:focus {
      border-color: #00e6b8;
    }
  }

  .my-health-title {
    text-align: left;
    font-size: 2rem;
    line-height: 2.5rem;
    margin-bottom: 0;
    font-family: "PlusJakartaSansBold";
  }

  .my-health-subtitle {
    flex: 1 1 100%;
    color: rgba(25, 37, 80, 0.8);
    font-size: 1.6rem;
    line-height: 2.4rem;
    font-family: "PlusJakartaSansRegular";
    text-align: left;
    margin: 4px 0 12px;
  }

  .my-health-img {
    width: 64px;
    height: 64px;
    object-fit: contain;
  }

  .my-health-tag-container {
    display: flex;
    align-items: center;
    text-align: left;
    font-size: 1.4rem;
    line-height: 1.8rem;
    font-family: "PlusJakartaSansBold";
  }
}
</style>
